<template>
  <v-card min-height="600" >
    <v-card-text>
      <v-tabs v-model="tabs" @change="editedItem = null">
        <v-tab key="variazioni">Variazioni</v-tab>
        <v-tab key="preparazioni">Preparazioni</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <v-tab-item key="variazioni">      
          <v-container fluid>
            <v-row no-gutters>  
              <v-col cols="7">
                <v-simple-table dense class="mt-1">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" width="15%">CATEGORIA</th>
                        <th class="text-left">DESCRIZIONE</th>
                        <th class="text-left" width="10%">AGGIUNGE</th>
                        <th class="text-left" width="10%">SOTTRAE</th>
                        <th class="text-left" width="10%">PREZZO +</th>
                        <th class="text-left" width="10%">PREZZO -</th>
                        <th class="text-left" width="10%">SOSTITUISCE</th>
                        <th class="text-left" width="8%"><v-btn icon @click.stop="onAggiungiVariazioni" title="Aggiungi variazioni"><v-icon>mdi-plus-circle-outline</v-icon></v-btn></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in variazioni" :key="index" @click="onClickRow(item)">
                        <td class="text-left">{{ item.categoria }}</td>
                        <td class="text-left">{{ item.descrizione }}</td>
                        <td class="text-left">{{ item.aggiunge ? 'SI' + (item.quantitaPiu ? ` (+${item.quantitaPiu}${item.unitaMisura || ''})` : '') : 'NO' }}</td>
                        <td class="text-left">{{ item.toglie ? 'SI' + (item.quantitaMeno ? ` (+${item.quantitaMeno}${item.unitaMisura || ''})` : '') : 'NO' }}</td>
                        <td class="text-left">{{ item.aggiunge ? item.deltaPrezzoPiu : '---' }}</td>
                        <td class="text-left">{{ item.toglie ? item.deltaPrezzoMeno : '---' }}</td>
                        <td class="text-left">{{ item.sostituisce ? item.sostituisce.descrizione : '' }}</td>
                        <td class="text-left">
                          <v-btn icon @click.stop="deleteItem(item, 'variazioni')" title="Cancella l'elemento"><v-icon small>mdi-delete</v-icon></v-btn>
                          <!-- <v-btn icon @click.stop="onNuovaVariazione(item, index)" title="Aggiungi una variazione" class="ml-2"><v-icon>mdi-plus-circle-outline</v-icon></v-btn> -->
                        </td>
                      </tr>
                    </tbody>                
                  </template>
                </v-simple-table>
              </v-col>
              <v-spacer></v-spacer>
              <v-col v-if="!editedItem" cols="4">
                <v-card
                  class="d-flex align-center mb-6"
                  flat
                  height="200"
                  tile
                >
                  <div class="pa-2 text-h5">Scegli la variazione da modificare</div>
                </v-card>        
              </v-col>
              <v-col v-else cols="4">
                <!-- <v-card-title>{{ editedItem.descrizione }}</v-card-title> -->
                <v-card-title>
                  <v-text-field v-model="editedItem.descrizione" hide-details class="text-h5 mb-3" outlined dense></v-text-field>
                </v-card-title>
                
                <v-card-subtitle>
                  <v-row no-gutters>
                    <v-col cols="12">Categoria: <span class="font-weight-medium">{{ editedItem.categoria }}</span></v-col>
                    <v-col cols="12">Codice: <span class="font-weight-medium">{{ editedItem.codice }}</span></v-col>
                  </v-row>
                </v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col cols="6"><v-switch v-model="editedItem.aggiunge" label="Variazione in aggiunta" class="mt-0"/></v-col>
                    <v-col cols="6"><v-text-field v-model="editedItem.deltaPrezzoPiu" label="Delta prezzo se aggiunta" hide-details clearable outlined dense></v-text-field></v-col>
                  </v-row>
                  <v-row v-if="editedItem.aggiunge" dense>
                    <v-col cols="7"></v-col>
                    <v-col cols="5"><v-text-field v-model="editedItem.quantitaPiu" label="Quantità se aggiunta" hide-details clearable outlined dense></v-text-field></v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6"><v-switch v-model="editedItem.toglie" label="Variazione in sottrazione" class="mt-0"/></v-col>
                    <v-col cols="6"><v-text-field v-model="editedItem.deltaPrezzoMeno" label="Delta prezzo se tolta" hide-details clearable outlined dense></v-text-field></v-col>
                  </v-row>
                  <v-row v-if="editedItem.toglie" dense>
                    <v-col cols="7"></v-col>
                    <v-col cols="5"><v-text-field v-model="editedItem.quantitaMeno" label="Quantità se tolta" hide-details clearable outlined dense></v-text-field></v-col>
                  </v-row>                  
                  <v-row>
                    <v-col cols="6">
                       <v-select
                        v-model="editedItem.sostituisce"
                        :items="prodottiDistinta"
                        no-data-text="Scegli un prodotto della distinta base"
                        label="Prodotto che sostituisce"
                        item-text="descrizione"
                        item-value="codice"
                        clearable
                        dense
                        hide-details="auto"
                        :outlined="true"
                        :return-object="true"
                        @click:clear="editedItem.sostituisce = null"
                      >
                      </v-select>
                    </v-col>
                  </v-row>                  
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="preparazioni">
          <v-container fluid>
            <v-row no-gutters>  
              <v-col cols="7">
                <v-simple-table dense class="mt-1">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" width="15%">CATEGORIA</th>
                        <th class="text-left">DESCRIZIONE</th>
                        <th class="text-left" width="10%">DELTA PREZZO</th>
              
                        <th class="text-left" width="8%"><v-btn icon @click.stop="onAggiungiPreparazioni" title="Aggiungi preparazioni"><v-icon>mdi-plus-circle-outline</v-icon></v-btn></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in preparazioni" :key="index" @click="onClickRow(item)">
                        <td class="text-left">{{ item.categoria }}</td>
                        <td class="text-left">{{ item.descrizione }}</td>
                        <td class="text-left">{{ item.deltaPrezzo ? item.deltaPrezzo : '---' }}</td>
                   
                        <td class="text-left">
                          <v-btn icon @click.stop="deleteItem(item, 'preparazioni')" title="Cancella l'elemento"><v-icon small>mdi-delete</v-icon></v-btn>
                          <!-- <v-btn icon @click.stop="onNuovaVariazione(item, index)" title="Aggiungi una variazione" class="ml-2"><v-icon>mdi-plus-circle-outline</v-icon></v-btn> -->
                        </td>
                      </tr>
                    </tbody>                
                  </template>
                </v-simple-table>
              </v-col>
              <v-spacer></v-spacer>
              <v-col v-if="!editedItem" cols="4">
                <v-card
                  class="d-flex align-center mb-6"
                  flat
                  height="200"
                  tile
                >
                  <div class="pa-2 text-h5">Scegli la preparazione da modificare</div>
                </v-card>        
              </v-col>
              <v-col v-else cols="4">
                <v-card-title>{{ editedItem.descrizione }}</v-card-title>
                <v-card-subtitle>Categoria: <span class="font-weight-medium">{{ editedItem.categoria }}</span></v-card-subtitle>
                <v-card-text>
                  <v-row>
                    <v-col cols="6"><v-text-field v-model="editedItem.deltaPrezzo" label="Delta prezzo se necessario" hide-details clearable outlined dense></v-text-field></v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" :disabled="!editedItem" @click="salvaModifiche">Salva</v-btn>
    </v-card-actions>    
    <aggiungi-variazioni :showDialog="dialogVariazioni" :editType="editType" @aggiornaVariazioni="saveDialogVariazioni" @aggiornaPreparazioni="saveDialogPreparazioni" />
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione riga ?</v-card-title>
        <v-card-text>{{ dettaglioRiga }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
          <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>  
</template>

<script>
  import AggiungiVariazioni from './aggiungiVariazioni'
  import documenti from '@/services/documentiService'
  export default {
    components: {
      AggiungiVariazioni
    },
    props: {
      item: Object,
      refresh: Number
    },
    data () {
      return {
        tabs: null,
        updateTrigger: 1,
        variazioni: [],
        preparazioni: [],
        prodottiDistinta: [],
        dialogVariazioni: false,
        dialogDelete: false,
        editedIndex: -1,
        editType: '',
        editedItem: null
      }
    },
    watch: {
      async refresh() {
        await this.aggiornaVariazioni()
      }
    },
    async mounted() {
      await this.aggiornaVariazioni()
    },
    computed: {
      dettaglioRiga() {
        let riga = this.editedIndex
        if (riga === -1) return
        let ed = this.editType === 'variazioni' ? this.variazioni[riga] : this.preparazioni[riga]
        if (!ed) return ''
        return ed.descrizione.trim()       
      }      
    },
    methods: {
      async onAggiungiVariazioni() {
        this.editType = 'variazioni'
        this.dialogVariazioni = true
        await this.$nextTick()
        this.dialogVariazioni = false
      },
      async onAggiungiPreparazioni() {
        this.editType = 'preparazioni'
        this.dialogVariazioni = true
        await this.$nextTick()
        this.dialogVariazioni = false
      },      
      async aggiornaVariazioni() {
        this.variazioni = this.item.variazioni || []
        this.preparazioni = this.item.preparazioni || []
        // this.prodottiDistinta = await this.getProdottiDistinta()
        this.prodottiDistinta = await documenti.getProdottiDistinta(this.item)

      },
/*       async getProdottiDistinta() {
        let elencoProdotti = []
        const codiceDistinta = _.get(this.item, 'bom.gestione.distinta.codice')
        if (codiceDistinta) {
          const documento = await documenti.getDocumento(codiceDistinta) 
          const distinta = documento.distinta || {}
          const elenco = this.elaboraItem(distinta, 1, 0)
          elencoProdotti = elenco.filter(x => ['prodotto', 'multiselect'].includes(x.tipo) && !x.semilavorato && x.livello > 0).map(x => { return { codice: x.codice, descrizione: x.descrizione }} )
        }
        return elencoProdotti
      }, */
/*       elaboraItem(item, qta = 1, livello) {
        if (!item) return []
        let elenco = []
        if (item.items) {
          elenco.push({ livello: livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione || '', quantita: +(qta * (item.quantita || 1)).toFixed(2), valore: item.valore, semilavorato: true, unitaMisura: item.unitaMisura })
          for (let i of item.items) {
            const totQta = qta * item.quantita
            elenco = elenco.concat(this.elaboraItem(i, totQta, livello + 1))
          }
        } else {
          let valori = item.valori || []
          elenco.push({ livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione || '', quantita: +(qta * (item.quantita || 1)).toFixed(2), valore: item.valore, semilavorato: false, unitaMisura: item.unitaMisura, valori: valori })
        }
        return elenco
      },  */     
      icona(item) {
      },
      titoloIcona(item) {
      },      
      onClickRow(item) {
        console.log('item', item)
        this.editedItem = item
        // this.editItemProdotto(item)
      },
      editItemProdotto (item) {

      },
      saveDialogVariazioni(variazioni) {
        const daAggiungere = variazioni.filter(x => !this.item.variazioni.find(y => y.codice === x.codice))
        if (daAggiungere.length > 0) {
          this.item.variazioni = this.item.variazioni.concat(daAggiungere)
          this.$emit('aggiornaVariazioni', this.item)
        }
      },
      saveDialogPreparazioni(preparazioni) {
        const daAggiungere = preparazioni.filter(x => !this.item.preparazioni.find(y => y.codice === x.codice))
        if (daAggiungere.length > 0) {
          this.item.preparazioni = this.item.preparazioni.concat(daAggiungere)
          this.$emit('aggiornaPreparazioni', this.item)
        }
      },
      salvaModifiche() {
        this.$emit(this.tabs === 0 ? 'aggiornaVariazioni' : 'aggiornaPreparazioni', this.item)
      },
      deleteItem (item, tipo) {
        if (tipo === 'variazioni') {
          this.editedIndex = this.item.variazioni.indexOf(item)
        }
        else if (tipo === 'preparazioni') {
          this.editedIndex = this.item.preparazioni.indexOf(item)
        }
        this.editType = tipo
        this.dialogDelete = true
      },      
      async deleteItemConfirm () {
        let v = this.editType === 'variazioni' ? this.item.variazioni : this.item.preparazioni
        v.splice(this.editedIndex, 1)
        this.closeDelete()
        this.editedIndex = -1
        this.editedItem = null
        this.$emit(this.editType === 'variazioni' ? 'aggiornaVariazioni' : 'aggiornaPreparazioni', this.item)
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedIndex = -1
          this.editType = ''
        })
      },
      itemCodice(item) {
        return {
          "model": "sostituisce",
          "valueField": "sostituisce",
          "label": "Sostituisce il codice",
          "type": "Prodotto",
          "required": false,
          "hint": "descrizione",
          "readOnly": true,
          "addForbidden": true,
          value: (item && item.sostituisce) || ''
        }
      },
      async componentValueChange(data) {
        const { model, subModel, value, decimals, index } = data
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.editedItem, tgt)
        await this.aggiornaCorrelati(data)
      },
      async aggiornaCorrelati(data) {
        switch (data.model) {
          case 'sostituisce':
           // if (data.value !== undefined) {
/*               this.editedItem.descrizione = _.get(data, 'item.descrizione', '')
              this.editedItem.unitaMisura = _.get(data, 'item.item.magazzino.unitaMisura', '')
              this.editedItem.richiedeLotto = _.get(data, 'item.item.isLotto', false) */
              // this.trigger++
           // }
            break
          default:
            break
        }
      }      
    }

  }
</script>

<style lang="scss" scoped>
  .v-input {
    font-size: 14px;
  }
  thead {
    background-color: rgb(222, 228, 233);
  }
  .manuale {
    background-color: rgb(193, 241, 183);
  }
  .mancanzaValore {
    color: red;
  }
</style>
